/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeTheme } from '@base/react';
import * as React from 'react';
import Comments from './comments/comments';
import PersonalItems from './personal-items';
import { useManageClassController } from '../../../../../../hooks/controllers/manage-class-controller';
import { useMessage } from '../../../../../../hooks/messages/useMessage';
import { AccordionItem } from './accordion';

export const Item = ({ name, id, comments, active, hidePortal, color }) => {
  const { getCompleteItemData } = useManageClassController();
  const { handleError } = useMessage();

  const [openItems, setOpenItems] = React.useState(new Set());
  const [openSubItemData, setOpenSubItemDat] = React.useState(new Set());
  const [openSubItemComments, setOpenSubItemComments] = React.useState(
    new Set(),
  );
  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  const handleGetPersonalData = React.useCallback(
    async (id) => {
      try {
        if (openSubItemData.has(id)) return;
        setLoading(true);
        const data = await getCompleteItemData(id);
        setItem(data);
      } catch (error) {
        handleError('Erro ao buscar detalhe do candidato(a)!');
      } finally {
        setLoading(false);
      }
    },
    [getCompleteItemData, handleError, openSubItemData],
  );

  const handleContent = () => {
    return (
      <div style={{ padding: '10px 0' }}>
        <AccordionItem
          inside={true}
          title="Dados do participante"
          isOpen={openSubItemData.has(id)}
          onToggle={() => {
            toggleSubItemData(id);
            handleGetPersonalData(id);
          }}
          bgTitleColor="#fff"
          titleColor="#000"
        >
          <PersonalItems
            id={id}
            item={item}
            loading={loading}
            isOpen={openSubItemData.has(id)}
          />
        </AccordionItem>

        <AccordionItem
          title="Comentários relevantes"
          inside={true}
          isOpen={openSubItemComments.has(id)}
          onToggle={() => toggleSubItemComments(id)}
          bgTitleColor="#fff"
          titleColor="#000"
        >
          <Comments comments={comments} idInterview={id} />
        </AccordionItem>
      </div>
    );
  };

  const COLOR = color ? color : '#355eb4';

  const toggleItem = React.useCallback((id) => {
    setOpenItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  }, []);

  const toggleSubItemComments = React.useCallback((id) => {
    setOpenSubItemComments((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  }, []);

  const toggleSubItemData = React.useCallback((id) => {
    setOpenSubItemDat((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  }, []);
  return (
    <>
      <AccordionItem
        key={id}
        title={name}
        isOpen={openItems.has(id)}
        onToggle={() => toggleItem(id)}
        bgTitleColor={COLOR}
        titleColor={BaSeTheme.colors.defaultColors.white}
      >
        {handleContent()}
      </AccordionItem>
    </>
  );
};
